import React, { memo } from 'react';
import { useIntl } from 'react-intl';

import { User as UserType } from '../../types/User';
import { Layout } from '../Layout/Layout';
import { Text } from '../Text/Text';
import { Tooltip } from '../Tooltip/Tooltip';
import { UserInfoOptions } from './types';
import { UserAvatar } from './UserAvatar';
import { UserName } from './UserName';

interface Props {
  user?: UserType;
  placeholder?: string;
  options?: UserInfoOptions;
}

export const UserInfo = memo(
  ({ options = {}, user, placeholder: initialPlaceholder }: Props) => {
    const intl = useIntl();
    const { date, info, infoTooltip } = options;

    const placeholder = initialPlaceholder
      ? initialPlaceholder
      : intl.formatMessage({
          id: 'Userinfo.placeholder',
          defaultMessage: 'Unknown User',
          description:
            'Placeholder text for user info when no user data is available',
        });

    return (
      <Layout align="center" spacing={2}>
        <UserAvatar
          options={{ date, size: 'l' }}
          user={user}
          placeholder={placeholder}
        />
        <Layout direction="column">
          <UserName
            mode="info"
            user={user}
            options={options}
            placeholder={placeholder}
          />
          <Tooltip tooltip={infoTooltip}>
            <Text preset="help">{info}</Text>
          </Tooltip>
        </Layout>
      </Layout>
    );
  },
);
